import styled from 'styled-components';

const Seperator = styled.div`
    margin-bottom: 30px;
    height: 1px;
    background-image: initial;
    background-color: rgb(48, 51, 54);
`;

export default Seperator;